import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { approveTask } from 'api/task.service';

export const useTaskApproveQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id }: { id: string }) => approveTask(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task approved successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
